const compares = document.querySelectorAll('.compare');
const sumInput = document.getElementById('sum-input');
const typeInputs = document.getElementsByName('loan_type');

compares.forEach((compare) => {
  compare.addEventListener('click', () => {
    const userSum = sumInput ? sumInput.value : null;
    const loanType = typeInputs.length ? typeInputs[0].value : null;
    dataLayer.push({
      'event': 'Choice_service_comparison',
      'service': loanType,
      'sum': userSum,
    });
  });
});
